import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {BranchModel} from "../../models/branch.model";

export class branchActiveDeliveriesCtrl implements IController {
  branch: BranchModel;
  agents: any;
  timeWindow: any;

  private loadLimit: number = 20;
  private deliveriesRef: any;
  private range: any;
  private selectedIds: [];
  private selectedAgent: any;
  private disableTimeSettings: boolean;
  private defaultGroup: any;
  private groupList: any;
  private filterConfig: any;
  private infiniteScroll: any;

  /* @ngInject */
  constructor(private $log, private $deliveries, private deliveriesConstants,
              private $infiniteScroll, private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private moment) {
  }

  $onInit() {

    this.range = this.dateRangeTimeFiltersService.today();
    this.deliveriesRef = this.$deliveries();

    this.selectedIds = [];
    this.selectedAgent = null;
    this.disableTimeSettings = false;
    this.defaultGroup = this.deliveriesConstants.group.Active;

    this.groupList = [
      this.deliveriesConstants.group.Unassigned,
      this.deliveriesConstants.group.Assigned,
      this.deliveriesConstants.group.Started,
      this.deliveriesConstants.group.Aborted
    ];

    this.filterConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: this._getRange(this.range, this.timeWindow),
      group: undefined,
      queryString: undefined,
      timeWindow: this.timeWindow,
      dateForTimeSlots: this.range.dateStart
    };

    this.deliveriesRef.$query(this._qetQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.deliveriesRef, this.loadLimit);
  }

  // ******************************
  //        Public methods
  // ******************************

  submitQuery(queryString) {
    this.filterConfig.queryString = queryString;
    this._query();
  }

  rangeChanged(range) {
    if (!_.isUndefined(range) && !_.isEqual(range.name, this.filterConfig.range.name)) {
      this.filterConfig.range = range;
      this.disableTimeSettings = this._getTimeSettingsAvailability(range);
      if (!this.disableTimeSettings) {
        this.filterConfig.dateForTimeSlots = range.dateStart;
      }
    }
  }

  onTimeWindowChange(timeWindow) {
    this.filterConfig.timeWindow = timeWindow;
    this.filterConfig.range = this._getRange(this.filterConfig.range, timeWindow);
    this._query();
  }

  onGroupChanged(group) {
    this.filterConfig.group = group;
    this._query();
  }

  // ******************************
  //        Private methods
  // ******************************

  _getRange(range, timeWindow) {
    if (timeWindow) {
      return {
        dateStart: this.moment(range.dateStart).hour(_.get(timeWindow, 'fromHour')).minute(_.get(timeWindow, 'fromMinute')).seconds(0).millisecond(0).valueOf(),
        dateEnd: this.moment(range.dateEnd).hour(_.get(timeWindow, 'toHour')).minute(_.get(timeWindow, 'toMinute')).seconds(0).millisecond(0).valueOf()
      }
    } else {
      return {
        dateStart: this.moment(range.dateStart).startOf('day').valueOf(),
        dateEnd: this.moment(range.dateEnd).endOf('day').valueOf()

      };
    }
  }

  _getTimeSettingsAvailability(range) {
    let dateStart = this.moment(range.dateStart).format("MM/DD/YYYY"),
      dateEnd = this.moment(range.dateEnd).format("MM/DD/YYYY");

    // Disable TIME picker if its not the same date.
    return !_.isEqual(dateStart, dateEnd);
  }

  _query() {
    this.selectedIds = [];
    this.deliveriesRef.$query(this._qetQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      }, (resp) => {
        this.$log.debug('Fail to $query', resp);
      });
  }

  _qetQueryPayload() {
    return {
      branchIds: [this.branch.id],
      // accountId:      ctrl.isDemand ? ctrl.account.id : undefined,
      agentIds: _.get(this.selectedAgent, 'id') ? [this.selectedAgent.id] : undefined,
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      group: this.filterConfig.group || this.defaultGroup,
      query: this.filterConfig.queryString,
      limit: this.loadLimit
    };
  }

  selectedIdsChanged(selectedIds) {
    this.selectedIds = selectedIds;
  }

  onSelectAgent(agent) {
    this.selectedAgent = agent;
    this._query();
  }

}

angular
  .module('bringoz.admin.branches')
  .component('branchActiveDeliveries', {
    bindings: {
      branch: '<',
      agents: '<',
      timeWindow: '<'
    },
    template: require('./branch-active-deliveries.html').default,
    controller: branchActiveDeliveriesCtrl
  });
